'use strict';

import * as angular from 'angular';

import * as Terminal from '../../components/termjs/term.js';
import * as _ from 'lodash';

export default angular.module('ttyView', [])
  .directive('ttyView', function($timeout, $rootScope, openApplicationMenu, Auth, User) {

    Terminal.prototype._refresh = Terminal.prototype.refresh;
    Terminal.prototype.refresh = function(start, end) {
      if(!this.refreshNotFirst || this.lastRefreshTime + 200 <= Date.now()){
        this.refreshNotFirst = true;
        this._refresh(start, end);
        this.lastRefreshTime = Date.now();
        return;
      }
      if(this.refreshTimer){
        start = 0;
        end = this.rows - 1;
        clearTimeout(this.refreshTimer);
      }
      this.refreshTimer = setTimeout(() => {
        this._refresh(start, end);
        this.lastRefreshTime = Date.now();
      }, 0);
    };

    return {
      template: require('./ttyview.directive.html').default,
      restrict: 'EA',
      scope: {
        ngModel: '=',
        container: '=',
        controller: '=',
        maximize: '@',
      },
      link: {
        pre: function(scope:any, element, attrs) {
          console.log("ttyview.directive:pre-link");
          scope.ngModel.iconText = '💻';
        },
        post: function(scope:any, element, attrs) {
          console.log("ttyview.directive:post-link");

          const defaultModel = {
            cols: 80,
            rows: 25,
          };

          scope.ngModel = Object.assign({}, defaultModel, scope.ngModel);

          scope.$on('windowManager.change', (event, wm) => {
            if(wm === 'floating'){
              Object.assign(scope.ngModel, defaultModel);
              scope.terminal.resize(scope.ngModel.cols, scope.ngModel.rows);
              if(server){
                console.log('tty.resize:', server.id, scope.terminal.cols, scope.terminal.rows);
                socket.emit('tty.resize', server.id, scope.terminal.cols, scope.terminal.rows);
              }

            }
          });

          scope.contextmenu = {};
          scope.$on('showApplicationMenu', (event, domEvent, source) => {
            openApplicationMenu(scope, '.ttyview-dropdown-menu' ,domEvent);
          });

          scope.isMobile = $rootScope.isMobile;
          $rootScope.$watch('isMobile', (post, pre) => {
            scope.isMobile = $rootScope.isMobile;
          });

          let container = scope.container;
          let containerId = container.containerId;

          scope.terminal = new (<any>Terminal)({cols: scope.ngModel.cols, rows: scope.ngModel.rows/*, termName: 'xterm-color'*/});
          const viewFrameElement = element.find('.viewFrame');
          const viewContentElement = element.find('.viewContent');
          scope.terminal.open(viewContentElement[0]);

          if(scope.ngModel.blink){
            scope.terminal.startBlink();
          }

          scope.$on('$destroy', function(){
            console.log('destoying terminal');
            scope.terminal.destroy();
            if(server) {
              console.log('sending tty.kill', server.id);
              socket.emit('tty.kill', server.id);
            }
            onDisconnectTty();
          });
          scope.title = '';

          function close(){
            scope.$emit('close');
            if(scope.onRemove){
              scope.onRemove();
            }
          }
          scope.killSession = () => {
            socket.ioSocket.emit('execFile', '/bin/bash', ['-c', `kill -HUP $(tmux list-windows -t "${server.sessionName}" -F "#{pane_pid}")`], {}, (error, stdout, stderr) => {
              console.log('execFile kill session done', error, stdout, stderr);
            });
          };
          scope.$watch('controller', (post, pre) => {
            if(scope.controller){
              scope.controller.close = (fDelete?) => {
                if(server) {
                  console.log('sending tty.kill', server.id);
                  if(fDelete){
                    scope.killSession();
                  }
                  socket.emit('tty.kill', server.id);
                }
              };
            }
          });

          let socket;
          let state;
          let server = scope.ngModel.server;

          function closeServer(){
            scope.ngModel.server = server = null;
          }

          function onDisconnectTty(){
            state = 'disconnected';
            scope.terminal.element.style.backgroundColor = 'gray';
            scope.terminal.element.style.borderColor = 'gray';
            clearInterval(scope.terminal._blink);
            delete scope.terminal._blink;
            scope.$emit('title', scope.title + ' (Disconnected)');

            if(socket && server) {
              socket.removeListener(`tty.data:${server.id}`);
              socket.removeListener(`tty.close:${server.id}`);
              socket.removeListener(`tty.exit:${server.id}`);
            }
            scope.terminal.handler = () => {};
          }

          scope.$watch('container.socket', (post, pre) => {
            console.log('ttyview: watch container.socket', post, pre);
            if(!post){
              return;
            }
            socket = container.socket;

            if(server) {
              state = 'restore';
            }else{
              let sessionName = Math.random().toString(36).substr(2); // eslint-disable-line newline-per-chained-call

              // Use socket.ioSocket instead of (Angular's)socket because Angular's socket call callback asynchronously,
              // so the callback miss the chance to setup listener for data event before handling the received message,
              // and lose the data event.

              const tmuxArgs = (<any>`-2 set -g status off ; set -g prefix M-C-b ; set -g set-titles on ; set -g default-terminal xterm-256color ; set -g set-titles-string #T ; new-session -d -s ${sessionName} "TMUX_SESSION_NAME=${sessionName} bash --login" ; attach-session -t ${sessionName}`.match(/\\?.|^$/g)).reduce((p: any, c) => {
                if (c === '"') {
                  p.quote ^= 1;
                } else if (!p.quote && c === ' ') {
                  p.a.push('');
                } else {
                  p.a[p.a.length - 1] += c.replace(/\\(.)/, "$1");
                }
                return p;
              }, {a: ['']}).a;

              socket.ioSocket.emit('tty.create', 'tmux', tmuxArgs, {
                cols: scope.ngModel.cols,
                rows: scope.ngModel.rows,
                name: 'xterm-color',
                removeOnDetach: true,
              }, (err, server_) => {
                scope.$apply(() => {
                  if (err) {
                    console.warn('tty.create:', err);
                    return close();
                  }
                  state = 'connected';
                  server_.sessionName = sessionName;
                  scope.ngModel.server = server = server_;
                  /* {pty:, id:} */
                  if (scope.container.ctrl.saveDesktop) {
                    scope.container.ctrl.saveDesktop();
                  }

                  onConnectTty();

                  let command = scope.ngModel.command;
                  if (command) {
                    let runCommand = _.once(() => {
                      scope.terminal.handler(command);
                    });
                    socket.on('systemd:ready', () => {
                      console.log('systemd:ready received');
                      runCommand();
                    });

                    socket.emit('readFile', '/tmp/systemd.ready', {}, (err, data) => {
                      console.log('readFile /tmp/systemd.ready', err, data);
                      if (!err) {
                        runCommand();
                      }
                    });
                  }
                });
              });
              state = 'connecting';
            }

            socket.on('disconnect', function(){
              scope.terminal.write("(The terminal was disconnected)\r\n");
              onDisconnectTty();
            });
            function onConnectTty(){
              scope.terminal.element.style.backgroundColor = scope.terminal.colors[256];
              scope.terminal.element.style.borderColor = scope.terminal.colors[256];

              console.log('tty.resize:', server.id, scope.terminal.cols, scope.terminal.rows);
              socket.emit('tty.resize', server.id, scope.terminal.cols, scope.terminal.rows);

              socket.on(`tty.data:${server.id}`, (data) => {
                scope.terminal.write(data);
              });
              socket.on(`tty.close:${server.id}`, () => {
                close();
              });
              socket.on(`tty.exit:${server.id}`, (code, signal) => {
                if (signal !== 0) {
                  window.swal('The terminal exited with code:' + code + ', signal:' + signal, 'error...', 'error');
                }
                if (scope.container.ctrl.saveDesktop) {
                  scope.container.ctrl.saveDesktop();
                }
                scope.terminal.destroy();
                onDisconnectTty();
                scope.ngModel.server = server = null;
              });
              // We could just hook in `tab.on('data', ...)`
              // in the constructor, but this is faster.
              scope.terminal.handler = (data) => {
                socket.emit('tty.data', server.id, data);
              };
            }
            function reconnectTty(){
              if(state === 'disconnected' || state === 'restore'){
                let fRefresh = (state === 'restore');
                let options = {};

                let sessionName = server.sessionName;
                socket.ioSocket.emit('tty.create', 'tmux', `attach-session -t ${sessionName}`.split(' '), {
                  cols: scope.ngModel.cols,
                  rows: scope.ngModel.rows,
                  name: 'xterm-color',
                  removeOnDetach: true,
                }, (err, server_) => {
                  scope.$apply(() => {
                    console.log('tty.attach', err, server_);
                    if (err) {
                      // return close();
                      onDisconnectTty();
                      scope.terminal.write("(Failed to attach)\r\n");
                      return;
                    }
                    scope.terminal.write("(Reconnected)\r\n");
                    state = 'connected';
                    server_.sessionName = sessionName;
                    scope.ngModel.server = server = server_;

                    onConnectTty();
                    if (fRefresh) {
                      socket.emit('tty.refresh', server.id);
                    }
                  });
                });
              }
              state = 'connecting';
            }
            socket.on('connect', () => {
              console.log('socket.on.connect event');
              reconnectTty();
            });
            reconnectTty();
          });

          scope.terminal.on('title', (title) => {
            console.log(`scope.terminal.on(title: ${title})`);
            scope.title = title;
            scope.$apply(function(){
              scope.$emit('title', title);
            });
          });
          scope.terminal.on('focus', () => {
            console.log("scope.terminal.on(focus):focusing=", scope.fucusing);
            if(scope.focusing){
              return;
            }
            scope.$apply(() => {
              scope.$parent.$emit('focus');
            });
          });

          scope.keypress = (ev) => {
            console.log('keypress:', ev);
          };
          scope.keydown = (ev) => {
            // Only keydown is fired on Chrome. (Safari fires both keypress and keydown)
            if(ev.metaKey && String.fromCharCode(ev.keyCode) === 'K' /*75*/){
              /* Command-K */
              let terminal = scope.terminal;

              terminal.lines = [terminal.lines[terminal.y + terminal.ydisp]];
              for(let i = 1; i < scope.terminal.rows; i++){
                terminal.lines.push(terminal.blankLine());
              }
              terminal.ybase = 0;
              terminal.ydisp = 0;
              terminal.y = 0;
              scope.terminal.refresh(0, scope.terminal.rows - 1);
            }
          };

          {
            let timer;
            scope.$on('resize', (event, ev) => {
              console.log("resize:event, ev=", event, ev);
              $timeout.cancel(timer);
              timer = $timeout(function(){
                resize();
                timer = null;
              }, 300);
            });
          }

          function resizeView(){
            if(scope.terminal.element.clientWidth === 0){
              console.log("clientWidth is 0. resizeView was postponed.");
              return;
            }

            let characterWidth = scope.terminal.element.clientWidth / scope.terminal.cols;
            let characterHeight = scope.terminal.element.clientHeight / scope.terminal.rows;

            let width = characterWidth * scope.terminal.cols + 10 + 2;
            let height = characterHeight * scope.terminal.rows + 10 + 2 + (window.isMobile ? <number>element.find(".ttyview-menu-bar").height() : 0);
            scope.$emit('resize view', width, height);
          }
          scope.$on('focus', (event, ev) => {
            if(scope.terminal.element.clientWidth === 0) {
              $timeout(() => {
                if (scope.terminal.element.clientWidth !== 0) {
                  resizeView();
                }
              }, 100);
            }else{
              resizeView();
            }
          });

          let toBeResized = false;
          function resize(){
            console.log("resize() started.");
            if(scope.terminal.element.clientWidth === 0){
              console.log("clientWidth is 0. resize was postponed.");
              /* if element.style.display==="none" */
              toBeResized = true;
              return;
            }
            toBeResized = false;

            scope.ngModel.cols = scope.terminal.cols;
            scope.ngModel.rows = scope.terminal.rows;

            let characterWidth = scope.terminal.element.clientWidth / scope.terminal.cols;
            let characterHeight = scope.terminal.element.clientHeight / scope.terminal.rows;
            let width = <number>viewFrameElement.width();
            let height = <number>viewFrameElement.height();
            let x = Math.floor((width - 10) / characterWidth);
            let y = Math.floor((height - 10) / characterHeight);
            console.log("ttyview:scope.terminal.resize:x=" + x + ", y=" + y + ", width=" + width + ", height=" + height + ", characterWidth=" + characterWidth + ", characterHeight=" + characterHeight);
            if(x === scope.terminal.cols && y === scope.terminal.rows){
              console.log("The same x and y.");
              return;
            }
            scope.terminal.resize(x, y);
            if(server){
              console.log('tty.resize:', server.id, scope.terminal.cols, scope.terminal.rows);
              socket.emit('tty.resize', server.id, scope.terminal.cols, scope.terminal.rows);
            }
            resizeView();
          }

          scope.sendData = (data) => {
            console.log('sendData', data);
            socket.emit('tty.data', server.id, data);
          };

          scope.$on('focus', (event, ev) => {
            console.log("ttyview: scope.on(focus)", event, ev);
            if(toBeResized){
              $timeout(() => {
                resize();
              }, 100);
            }
            scope.focusing = true;
            scope.terminal.focus();
            scope.focusing = false;
            if(!element.is(":visible")){
              $timeout(() => {
                scope.focusing = true;
                scope.terminal.focus();
                scope.focusing = false;
              }, 300);
            }
          });

          let appConfig;
          let terminalStyle = scope.terminal.element.style;
          scope.setFontSize = (fontSize) => {
            appConfig.general.fontSize = fontSize;
            scope.currentUser.saveApplicationConfigs();
          };
          scope.setBackgroundColor = (backgroundColor) => {
            appConfig.general.backgroundColor = backgroundColor;
            scope.currentUser.saveApplicationConfigs();
          };

          $timeout(() => {
            resizeView();

            Auth.getCurrentUser((user) => {
              scope.currentUser = user;
              scope.currentUser.applicationConfigs = scope.currentUser.applicationConfigs || {};
              scope.currentUser.applicationConfigs.terminal = scope.currentUser.applicationConfigs.terminal || {};
              appConfig = scope.currentUser.applicationConfigs.terminal;
              appConfig.general = appConfig.general || {};

              scope.$watch('currentUser.applicationConfigs.terminal.general.fontSize', (post, pre) => {
                if(!post){
                  return;
                }
                const fontSize = appConfig.general.fontSize;
                if (terminalStyle.fontSize !== `${fontSize}px`){
                  terminalStyle.fontSize = `${fontSize}px`;
                  resize();
                }
              });
              scope.$watch('currentUser.applicationConfigs.terminal.general.backgroundColor', (post, pre) => {
                if(!post){
                  return;
                }
                const backgroundColor = appConfig.general.backgroundColor;
                if (terminalStyle.backgroundColor !== backgroundColor){
                  if(backgroundColor === 'black') {
                    terminalStyle.color = '#f0f0f0';
                    terminalStyle.backgroundColor = terminalStyle.borderColor = '#000';
                  }else{
                    terminalStyle.color = 'black';
                    terminalStyle.backgroundColor = terminalStyle.borderColor  = 'white';
                  }
                  scope.terminal.colors[256] = terminalStyle.backgroundColor;
                  scope.terminal.colors[257] = terminalStyle.color;
                }
              });
            });

          });
        },
      },
    };
  }).name;
